export default __webpack_public_path__ + "static/media/yellow5en.84fb83a8.jpg";